var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddPhotoEpDsk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAddPhotoEpDsk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.7383015,22.7556342 L38.6862443,10.8076774 C39.7860667,9.70785366 39.7860667,7.9246916 38.6862443,6.82502517 C37.5864218,5.7252014 35.8034191,5.7252014 34.7035967,6.82502517 L22.7554966,18.7731393 L10.8073964,6.82486783 C9.70757396,5.72504406 7.92457134,5.72504406 6.82474885,6.82486783 C5.72508372,7.9246916 5.72508372,9.70785366 6.82474885,10.8075201 L18.772849,22.7554769 L6.82474885,34.703591 C5.72508372,35.8034148 5.72508372,37.5865769 6.82474885,38.6862433 C7.92457134,39.7860671 9.70757396,39.7860671 10.8073964,38.6862433 L22.7554966,26.7381291 L34.7035967,38.6862433 C35.8032618,39.7860671 37.5864218,39.7860671 38.6862443,38.6862433 C39.7860667,37.5864195 39.7860667,35.8034148 38.6862443,34.703591 L26.7383015,22.7556342 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Manage-Photos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icAddPhotoEpDsk",
    fill: "#A5A5A5",
    fillRule: "nonzero",
    transform: "translate(22.755556, 22.755556) rotate(-44.000000) translate(-22.755556, -22.755556) ",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddPhotoEpDsk);
export default __webpack_public_path__ + "static/media/icAddPhotoEpDsk.0b77b1ad7777b15a1dd097d571e93729.svg";
export { ForwardRef as ReactComponent };